/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { task } from 'ember-concurrency';

@tagName('')
export default class CioModalSplitSelectWinner extends Component {
  @service api;
  @service apiErrors;

  onDeleteConfirmed() {}

  @computed('splitTest.splitActions.[]')
  get otherSplitActions() {
    return this.get('splitTest.splitActions').without(this.get('winner'));
  }

  selectWinner = task(
    {
      drop: true,
    },
    async () => {
      let winner = this.get('winner.action');

      let promise = this.get('splitTest').selectSplitWinner({
        campaignId: winner.get('campaign.id'),
        winnerId: winner.get('id'),
      });

      this.get('apiErrors').attach(promise);

      this.onDeleteConfirmed();

      await promise;

      this.onSuccess();
    },
  );
}
